import { render, staticRenderFns } from "./Equipes.vue?vue&type=template&id=64791209&scoped=true&"
import script from "./Equipes.vue?vue&type=script&lang=js&"
export * from "./Equipes.vue?vue&type=script&lang=js&"
import style0 from "./Equipes.vue?vue&type=style&index=0&id=64791209&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64791209",
  null
  
)

export default component.exports